import { getItemHighlight, getSecondaryHighlight } from "./utils";

export function getEmployeeTemplate(item, html) {
  return html` <div class="aa-ItemWrapper">
    <div class="aa-ItemContent">
      <div class="aa-ItemIcon aa-ItemIcon--alignTop">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="users"
          class="svg-inline--fa fa-users "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          height="24"
          width="24"
        >
          <path
            fill="currentColor"
            d="M144 160c-44.2 0-80-35.8-80-80S99.8 0 144 0s80 35.8 80 80s-35.8 80-80 80zm368 0c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM416 224c0 53-43 96-96 96s-96-43-96-96s43-96 96-96s96 43 96 96zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"
          ></path>
        </svg>
      </div>
      <div class="aa-ItemContentBody">
        <div class="aa-ItemContentTitle">
          ${getItemHighlight(html, item, "employee.first_name")}
          ${getItemHighlight(html, item, "employee.last_name")}
          ${getItemHighlight(html, item, "employee.email")}
        </div>
        <div class="aa-ItemContentDescription">
          ${getSecondaryHighlight(html, item, "employee.email")}
          <span class="orgid label label-default"
            >Org ID: ${item.document["employee.organisation_id"]}</span
          >
          <span class="text-danger ml-1">
            (${item.document["employee.organisation_name"]})</span
          >
        </div>
      </div>
    </div>
  </div>`;
}
